<template>
    <div>
        <el-form
            ref="form"
            :model="form"
            label-width="120px"
            style="form"
            :rules="rules"
        >
            <el-form-item label="选择客户" prop="title">
                <el-row>
                    <el-col :span="12">
                        <el-input v-model="form.title"></el-input>
                    </el-col>
                    <el-col :span="4">
                        <div style="width: 100%; height: 10px"></div>
                    </el-col>
                    <el-col :span="8">
                        <el-button type="primary" @click="add" size="medium"
                            >选择客户</el-button
                        >
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
                <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input v-model="form.address"></el-input>
            </el-form-item>
            <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="服务类型" prop="title">
            <el-select v-model="form.region" placeholder="请选择服务类型" style="width:100%">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <div style="width:100%;height:10px"></div>
        </el-col>
        <el-col :span="10">
          <el-form-item label="服务项目" prop="title">
            <el-select v-model="form.region" placeholder="请选择服务项目" style="width:100%">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
            <el-form-item label="服务类型" prop="title">
                <el-row>
                    <el-col :span="12">
                        <el-input v-model="form.title"></el-input>
                    </el-col>
                    <el-col :span="4">
                        <div style="width: 100%; height: 10px"></div>
                    </el-col>
                    <el-col :span="8">
                        <el-button type="primary" @click="add" size="medium"
                            >选择服务类型</el-button
                        >
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="服务项目" prop="title">
                <el-row>
                    <el-col :span="12">
                        <el-input v-model="form.title"></el-input>
                    </el-col>
                    <el-col :span="4">
                        <div style="width: 100%; height: 10px"></div>
                    </el-col>
                    <el-col :span="8">
                        <el-button type="primary" @click="add" size="medium"
                            >选择服务项目</el-button
                        >
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="计划服务时间" prop="endTime ">
                <el-date-picker
                    v-model="form.endTime"
                    type="datetime"
                    placeholder="选择日期时间"
                ></el-date-picker>
            </el-form-item>

            <el-form-item label="服务要求" prop="requirement">
                <el-input v-model="form.requirement"></el-input>
            </el-form-item>

            <el-form-item label="服务公司" prop="title">
                <el-select
                    v-model="form.region"
                    placeholder="请选择服务公司"
                    style="width: 50%"
                >
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="currentPage1"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total1"
                ></el-pagination>
            </div>
            <el-form-item label="审核说明" v-if="auditShow && auditState == 4">
                <el-input type="textarea" v-model="explains"></el-input>
            </el-form-item>
            <div class="button" v-if="buttonType == 'add'">
                <el-button type="primary" @click="save">确定</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
            </div>
            <div class="button" v-if="buttonType == 'compile'">
                <el-button type="primary" @click="save">编辑</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
            </div>
        </el-form>
        <!--  -->
        <el-dialog
            title="选择客户"
            :visible.sync="selectVisible"
            :modal="false"
            width="70%"
        >
            <!-- 表格 -->
            <div class="table">
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    border
                    style="width: 100%"
                    @select="handleSelectionChange"
                    @select-all="changeAll"
                    row-key="id"
                >
                    <el-table-column
                        type="selection"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        v-for="(item, index) in tableColumn"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        header-align="center"
                    >
                        <template slot-scope="scope">
                            <div v-if="item.type == 'state'">
                                <div style="text-align: center">
                                    <el-tag v-if="scope.row.state == 1"
                                        >待审核</el-tag
                                    >
                                    <el-tag
                                        v-if="scope.row.state == 2"
                                        type="success"
                                        >通过</el-tag
                                    >
                                    <el-tag
                                        v-if="scope.row.state == 3"
                                        type="danger"
                                        >不通过</el-tag
                                    >
                                </div>
                            </div>
                            <div
                                v-else
                                :style="{
                                    'text-align': item.align
                                        ? item.align
                                        : 'center',
                                }"
                            >
                                {{ scope.row[item.prop] }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sure">确定</el-button>
            </span>
        </el-dialog>

        <!--  -->
        <el-dialog
            title="选择服务类型"
            :visible.sync="selectVisible1"
            :modal="false"
            width="70%"
        >
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sure1">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import uploadImgs from "@/component/uploadImgs/index.vue"
import request from "@/utils/request.js"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import editor_option from "../../../../utils/editorOption.js"
import { quillEditor } from "vue-quill-editor"
// import {
//   getAllChildrenPolicyClassifyList,
//   getAllChildrenPolicyData,
//   helpManagePublicityList,
//   helpManagePublicityDelete,
//   helpManagePublicityEdit,
//   helpManagePublicityCheck,
//   oldManFileList,
//   getRecordData
// } from "../api/index.js";
import upload from "@/component/componentsP/upImg.vue"
export default {
    components: { uploadImgs, quillEditor, upload },
    props: ["title", "buttonType", "row"],
    data() {
        return {
            form: {},
            editDisable: false,
            uploadUrl:
                request.defaults.baseURL + "/oneStopUpload/info/uplodfiles",
            tableData: [],
            tableColumn: [
                {
                    prop: "name",
                    label: "姓名",
                },
                {
                    type: "sex",
                    prop: "sex",
                    label: "性别",
                },
                {
                    prop: "age",
                    label: "年龄",
                },
                {
                    prop: "phone",
                    label: "联系电话",
                },
                {
                    prop: "idCode",
                    label: "身份证号",
                },
                // {
                //   prop: "nationType",
                //   label: "救助状态"
                // },
            ],
            editorOption: editor_option.editorOption,
            data: [],
            defaultProps: {
                children: "children",
                label: "childrenPolicyTypeName",
            },
            auditShow: false,
            auditState: 3,
            currentPage1: 1,
            fileList: [],
            typeImg: "",
            defaultCheckedKeys: [],
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                // startTime: [{ required: true, message: "请输入标题", trigger: "blur" }],
                startTime: [
                    {
                        required: true,
                        message: "请选择公示期限开始时间",
                        trigger: "blur",
                    },
                ],
                endTime: [
                    {
                        required: true,
                        message: "请选择公示期限结束时间",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: "请输入电子邮箱",
                        trigger: "blur",
                    },
                ],
                state: [
                    {
                        required: true,
                        message: "请选择审核说明",
                        trigger: "blur",
                    },
                ],
                grantTime: [
                    {
                        required: true,
                        message: "请选择发放日期",
                        trigger: "blur",
                    },
                ],
            },
            tableData: [], //
            totalHome: "",
            currentPageHome: "",
            selectChildrenList: [],
            tableColumnListList: [],
            selectVisible: false,
            pageNo: 1,
            pageSize: 10,
            total: 1,
            pageNo1: 1,
            pageSize1: 5,
            total1: 1,
            currentPage: 1,
            treeData: {}, //选中的树
        }
    },
    methods: {
        //保存按钮
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log("this.fileList", this.fileList)
                    let homePhoto = ""
                    this.fileList.forEach((item) => {
                        homePhoto += item.path + ";"
                    })

                    this.$set(this.form, "enclosure", homePhoto)
                    console.log(homePhoto)
                    console.log(this.tableData)
                    this.$set(
                        this.form,
                        "longList",
                        this.tableData.map((item) => item.id)
                    )
                    // this.$set(this.form, "auditStatus", 0);
                    // this.$emit("save", this.form, "保存");
                    helpManagePublicityEdit(this.form).then((res) => {
                        this.$message({
                            type: "success",
                            message: "保存成功",
                        })
                        this.$emit("cancel")
                    })
                }
            })
            // this.$set(this.form,'homePhoto',this.fileListString[0])
            // this.$set(this.form,'longitude','111,111')
            // this.$set(this.form,'homePhoto','111,211')
        },
        //编辑
        compile() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let homePhoto = ""
                    this.fileList.forEach((item) => {
                        homePhoto += item.url + ";"
                    })
                    if (
                        !this.treeData ||
                        Object.keys(this.treeData).length == 0
                    ) {
                        this.$message({
                            type: "warning",
                            message: "请选择信息分类",
                        })
                        return false
                    }
                    this.$set(this.form, "homePhoto", homePhoto)
                    this.$set(
                        this.form,
                        "childrenPolicyTypeId",
                        this.treeData.id
                    )
                    // this.$set(this.form, "auditStatus", 0);
                    this.$emit("save", this.form, "编辑")
                }
            })
            // this.$set(this.form,'homePhoto',this.fileListString[0])
            // this.$set(this.form,'longitude','111,111')
            // this.$set(this.form,'homePhoto','111,211')
        },
        //提交
        submit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (
                        !this.treeData ||
                        Object.keys(this.treeData).length == 0
                    ) {
                        this.$message({
                            type: "warning",
                            message: "请选择信息分类",
                        })
                        return false
                    }
                    this.$set(
                        this.form,
                        "childrenPolicyTypeId",
                        this.treeData.id
                    )
                    this.$set(this.form, "auditStatus", 1)
                    this.$emit("save", this.form, "提交")
                }
            })
        },
        //取消
        cancel() {
            this.$emit("cancel")
        },
        //回写拿到数据
        getAllChildrenPolicyDataAPI(e) {
            helpManagePublicityCheck(e).then((res) => {
                console.log("回写数据", res.content)

                this.form = res.content
                if (res.content.enclosure) {
                    let arr = res.content.enclosure.split(";")
                    arr.pop()
                    this.fileList = arr.map((item) => {
                        return {
                            path: item,
                            name: item,
                        }
                    })
                    this.typeImg = "compile"
                }

                console.log(res.content.childrenPolicyTypeId)

                this.defaultCheckedKeys = [res.content.childrenPolicyTypeId]
                this.treeData = { id: res.content.childrenPolicyTypeId }
            })
        },
        //拿到政策类型
        getAllChildrenPolicyClassifyListAPI(e) {
            getAllChildrenPolicyClassifyList(e).then((res) => {
                console.log("", res.content)
                this.data = res.content
            })
        },
        //信息分类
        getCheckedNodes(e, data, form) {
            this.$refs.tree.setCheckedKeys([])
            this.$refs.tree.setCheckedKeys([e.id])
            // console.log("e", e);
            this.treeData = e
        },
        //审核
        audit() {
            this.$set(this.form, "auditStatus", this.auditState)
            console.log("auditStatus", this.auditState)
            this.$emit("save", this.form, "审核")
        },
        successImg(e) {
            this.fileList = e
        },

        deleteImg(e) {
            this.fileList = e
        },
        //选择政策分类
        handleSelectionChange(val) {
            console.log("val", val)
            this.selectChildrenHome = val
            // if (val && val.length > 0) {
            //   this.$refs.multipleTable.clearSelection();
            //   this.$refs.multipleTable.toggleRowSelection(val[val.length - 1], true);
            //   this.selectChildrenHome = [val[val.length - 1]];
            // } else {
            //   this.selectChildrenHome = [];
            // }
            // this.childrenShow = true;
        },
        //点击选择政策分类全选按钮
        changeAll(e) {
            console.log("e", e)
            this.selectChildrenHome = e
        },
        //政策分类每页请求数据
        handleSizeChange(val) {
            this.pageSize = val
            this.helpManagePolicyTypeListAPI()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //政策分类请求第几数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.helpManagePolicyTypeListAPI()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        //政策分类每页请求数据
        handleSizeChange1(val) {
            this.pageSize1 = val
            this.helpManagePolicyTypeListAPI1()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //政策分类请求第几数据
        handleCurrentChange1(val) {
            this.pageNo1 = val
            this.helpManagePolicyTypeListAPI1()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        //选择政策分类
        add() {
            this.selectVisible = true
            this.helpManagePolicyTypeListAPI()
        },
        //拿到政策分类的列表
        helpManagePolicyTypeListAPI(e) {
            let params = Object.assign({}, e, {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            })
            oldManFileList(params).then((res) => {
                this.tableData = res.content.list
                this.total = res.content.count
            })
        },
        // //拿到政策分类的列表
        // helpManagePolicyTypeListAPI1(e) {

        //   let params = Object.assign({}, e, {
        //     pageNo: this.pageNo1,
        //     pageSize: this.pageSize1,
        //     publicityId: this.row.id
        //   });
        //   oldManFileList(params).then(res => {
        //     this.tableData = res.content.list;
        //     this.total = res.content.count;
        //   });
        // },
        sure() {
            this.tableColumnListList = this.selectChildrenHome
            this.selectVisible = false
        },
        //移除选择的政策分类
        remove(e) {
            let index = this.tableColumnListList.findIndex(
                (item) => item.id == e.id
            )
            this.tableColumnListList.splice(index, 1)
        },
        //回写拿到数据
        helpManagePolicyTypeListAPI1(e) {
            let params = Object.assign({}, e, {
                pageNo: this.pageNo1,
                pageSize: this.pageSize1,
                publicityId: this.row.id,
            })
            getRecordData(params).then((res) => {
                console.log("回写数据", res.content)
                this.tableColumnListList = res.content.list
            })
        },
    },
    created() {
        // this.getCityAPI(1, 1);
        console.log(this.buttonType)
        // this.getAllChildrenPolicyClassifyListAPI({});
        //根据this.buttonType的值来判断点的是什么按钮
        if (this.buttonType == "check" || this.buttonType == "compile") {
            this.getAllChildrenPolicyDataAPI({ id: this.row.id })
            this.helpManagePolicyTypeListAPI1()
        }
    },
}
</script>

<style scoped>
.left {
    width: 44%;
    display: inline-block;
}
.right {
    width: 45%;
    display: inline-block;
    float: left;
}
.flex {
    display: flex;
}
.itemSelect {
    width: 30%;
}
.map {
    width: 100%;
    height: 120px;
    background-color: red;
}
.button {
    width: 400px;
    margin: 30px auto 0px;
    display: flex;
    justify-content: space-between;
}
.title {
    border: 1px solid rgb(175, 175, 175);
    text-align: center;
    padding: 10px 0px;
    margin: 10px 0px;
}
.el-form-item {
    margin-bottom: 20px !important;
}
.tip {
    text-align: center;
    margin: 10px 0px;
    color: red;
}
</style>